export class AppLockedError extends Error {}
